import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import React from 'react';

export default function PrimaryButton(props) {
	const {
		value,
		onClick,
		startIcon,
		endIcon,
		className,
		backgroundColor,
		height,
		fontSize,
		padding,
		fontWeight,
		disabled = false,
		textcolor,
		borderRadius,
		width,
		marginRight,
		customStyle,
		type,
		minWidth,
		btnClass,
		maxHeight,
		alignItems,
		display,
		marginTop,
		border,
		hoverbackgroundColor,
		disabledStyle = { backgroundColor: '#D9D9D9', opacity: '0.7' },
		...other
	} = props;

	const buttonStyle = {
		width: width || 'auto',
		height: height || 'auto',
		fontSize: fontSize || '',
		fontWeight: fontWeight || '',
		marginRight: marginRight || 'none',
		borderRadius: borderRadius || '',
		bgcolor: backgroundColor || 'transparent',
		color: textcolor || 'inherit',
		padding,
		textTransform: 'none',
		minWidth: minWidth || 'none',
		maxHeight: maxHeight || 'none',
		display: display || '',
		alignItems: alignItems || 'none',
		marginTop: marginTop || 'none',
		border: border || 'none',
		boxShadow: 'none',
		...customStyle,
		'&:hover': {
			bgcolor: hoverbackgroundColor || backgroundColor
		},
		'&.Mui-disabled': disabledStyle
	};

	return (
		<Button
			variant='contained'
			startIcon={startIcon}
			endIcon={endIcon}
			onClick={onClick}
			className={btnClass}
			sx={{ ...buttonStyle }}
			disabled={disabled}
			type={type}
			{...other}
			disableElevation
		>
			<span className={className}>{value}</span>
		</Button>
	);
}

// Prop Types Validation
PrimaryButton.propTypes = {
	value: PropTypes.any,
	onClick: PropTypes.any,
	startIcon: PropTypes.any,
	endIcon: PropTypes.any,
	className: PropTypes.any,
	backgroundColor: PropTypes.any,
	height: PropTypes.any,
	fontSize: PropTypes.any,
	padding: PropTypes.any,
	fontWeight: PropTypes.any,
	disabled: PropTypes.any,
	textcolor: PropTypes.any,
	borderRadius: PropTypes.any,
	width: PropTypes.any,
	marginRight: PropTypes.any,
	customStyle: PropTypes.any,
	type: PropTypes.any,
	minWidth: PropTypes.any,
	btnClass: PropTypes.any,
	maxHeight: PropTypes.any,
	alignItems: PropTypes.any,
	display: PropTypes.any,
	marginTop: PropTypes.any,
	boxShadow: PropTypes.any,
	border: PropTypes.any,
	hoverbackgroundColor: PropTypes.any,
	disabledStyle: PropTypes.any
};
